// extracted by mini-css-extract-plugin
export default {"container":"AddProductForm_container__2HFyJ","imageUploadContainer":"AddProductForm_imageUploadContainer__aSmwH","title":"AddProductForm_title__kkKQK"};